import React, { FC, memo } from "react";

import { DEFAULT_GRADIENT_COLOR } from "../../constants";
import { LinearGradientProps } from "./types";

export const LinearGradient: FC<LinearGradientProps> = memo(({ id, colors }) => {
  return (
    <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
      {colors?.map((color, index) => (
        <stop key={index} offset={index / (colors?.length - 1)} stopColor={color || DEFAULT_GRADIENT_COLOR} />
      ))}
    </linearGradient>
  );
});
